<template>
  <div class="text-center">
    <v-dialog v-model="show" @click:outside="close" max-width="420">
      <v-card v-if="item">
        <v-container>
          <!-- Mensaje de error (si falla la carga de la CLABE) -->
          <v-alert
            v-if="errorMessage"
            type="error"
            prominent
            dense
            class="mb-3"
          >
            {{ errorMessage }}
          </v-alert>
          <div class="text-h5 text-center">
            {{ item.supplier?.business_name ?? "-" }}
          </div>

          <div class="align-center my-4">
            <PaymentAmount
              :payment="item"
              class="flex justify-center"
              totalAmountClass="text-h4 font-weight-bold text-center"
              :showDetails="true"
            />
          </div>
          <div class="text-subtitle text-center">
            Vencimiento: {{ item.expiration_date ?? "-" }}
          </div>

          <v-card-text class="mt-4 text-center">
            <v-alert
              color="#4CAF50"
              border="left"
              style="font-size: 1em; font-weight: bold"
              icon="mdi-information-outline"
              outlined
              prominent
            >
              Realizá una transferencia a la siguiente CLABE. Te enviaremos un
              correo de confirmación cuando impacte el pago.
            </v-alert>

            <v-row class="mt-2" align="center" justify="center">
              <v-col cols="12">
                <div class="text-subtitle-1 font-weight-bold mb-1">
                  CLABE STP
                  <!-- Payment type indicator (optional) -->
                  <v-chip
                    v-if="item.is_factoring"
                    x-small
                    color="orange"
                    outlined
                    class="ml-2"
                  >
                    Factoraje
                  </v-chip>
                </div>

                <div v-if="loadingClabe" class="my-2">
                  <v-progress-circular
                    indeterminate
                    size="24"
                  ></v-progress-circular>
                </div>

                <div v-else class="text-h6 d-flex align-center justify-center">
                  <span class="mr-2">{{ stpClabe || "-" }}</span>
                  <CopyBtn v-if="stpClabe" :content="stpClabe" />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1d1d1f" style="color: #fff" @click="close">
            Entendido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PaymentService from "../services/paymentService";
import SentryService from "../services/sentryService";
import CopyBtn from "@/components/CopyBtn";
import PaymentAmount from "./payment/PaymentAmount.vue";

export default {
  props: ["visible", "item"],

  components: {
    CopyBtn,
    PaymentAmount,
  },

  data: () => ({
    stpClabe: null,
    loadingClabe: false,
    errorMessage: "",
  }),

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) this.$emit("close");
      },
    },
  },

  methods: {
    async fetchStpClabe() {
      if (!this.item || !this.item.id) return;

      this.loadingClabe = true;
      this.errorMessage = "";

      try {
        const response = await PaymentService.getStpClabe(this.item.id);
        
        // Verificar que response sea válido y tenga el método json
        if (!response || typeof response.json !== 'function') {
          this.errorMessage = "Error de conexión. Inténtalo nuevamente en unos minutos.";
          SentryService.captureMessage(
            "Response inválido en fetchStpClabe",
            "error",
            { paymentId: this.item.id, response: typeof response }
          );
          return;
        }

        const result = await response.json();

        if (response.ok) {
          this.stpClabe = result?.clabe || null;

          if (!this.stpClabe) {
            this.errorMessage =
              "Ocurrio un error, intentalo nuevamente en unos minutos.";
            SentryService.captureMessage(
              "Respuesta sin CLABE STP en fetchStpClabe",
              "warning",
              { paymentId: this.item.id, result }
            );
          }
        } else {
          this.errorMessage =
            result?.msg ||
            "Ocurrio un error, intentalo nuevamente en unos minutos.";
          SentryService.captureMessage(
            `Error HTTP ${response.status} en fetchStpClabe`,
            "error",
            { paymentId: this.item.id, result }
          );
        }
      } catch (error) {
        this.errorMessage =
          "Ocurrio un error, intentalo nuevamente en unos minutos.";
        SentryService.captureError(error, {
          action: "reportPayment.fetchStpClabe",
          paymentId: this.item?.id || null,
        });
      } finally {
        this.loadingClabe = false;
      }
    },

    close() {
      this.stpClabe = null;
      this.loadingClabe = false;
      this.errorMessage = "";
      this.$emit("close");
    },
  },

  watch: {
    async show(val) {
      if (val) {
        await this.fetchStpClabe();
      }
    },
  },
};
</script>
